import { actionCopyEs } from "./actionCopy";

export const authCopyEs = {
    backToWebsite: "Volver al sitio web",
    languageLabel: "Language / Sprache / Sprog / Idioma",
    languageDescription:
        "Change the app language. Sprache der App ändern. Skift appsprog. Cambie el idioma de la aplicación.",
    chooseLanguage: "Elegir el idioma",
    or: "O",
    next: actionCopyEs.next,
    submit: actionCopyEs.submit,
    continue: actionCopyEs.continue,
    logout: "Cerrar sesión",
    verifyingAuthentication: "Verificando la autenticación...",
    signUpSignIn: "Registro / Acceso",
    signIn: "Iniciar sesión",
    signUp: "Registrarse",
    signUpWith: (name) => `Registrarse con ${name}`,
    alreadyHaveAccount: "¿Ya tiene una cuenta?",
    dontHaveAccount: "¿No tiene una cuenta?",
    signInWithPasswordInstead: "Iniciar sesión con una contraseña",
    contactMethodLabel: "Medio de contacto",
    patientRole: "Paciente",
    forgotPassword: "Contraseña olvidada",
    confirmYourAccount: "Confirme su cuenta",
    choosePassword: "Elegir una contraseña",
    confirmPassword: "Confirmar la contraseña",
    showPassword: "Mostrar la contraseña",
    passwordsDontMatch: "Las contraseñas no coinciden",
    passwordsMatch: "Las contraseñas coinciden",
    passwordAllGood: "¡Perfecto!",
    passwordRequirementMinLength: "Debe contener al menos 8 caracteres",
    passwordRequirementLowercase: "Debe contener una letra minúscula",
    passwordRequirementUppercase: "Debe contener una letra mayúscula",
    passwordRequirementNumber: "Debe contener un número",
    passwordRequirementSpecial: "Debe contener un carácter especial",
    setYourPassword: "Defina su contraseña",
    setPasswordDescription: "Cree una contraseña segura para su cuenta",
    settingPassword: "Configurando la contraseña...",
    smartAuthHint:
        "Introduzca la dirección de correo electrónico o el número de teléfono al que se envió su invitación de Patient Watch.",
    usePhoneInstead: "Usar el teléfono",
    useEmailInstead: "Usar el correo electrónico",
    phoneVerificationHint: "Le enviaremos un código de verificación a su teléfono.",
    phoneSignupHint:
        "Le enviaremos un código de verificación a su teléfono. Pueden aplicarse las tarifas estándar de mensajes.",
    loggingIn: "Iniciando sesión...",
    sendingCode: "Enviando el código...",
    logIn: "Iniciar sesión",
    sendCode: "Enviar el código",
    sendVerificationCode: "Enviar el código de verificación",
    sendingCodeEllipsis: "Enviando el código…",
    codeSent: "Código enviado",
    codeSentToPhone: "Código enviado a su teléfono",
    verificationCodeSent: "Código de verificación enviado",
    emailFallbackCodeSent:
        "No ha sido posible enviar un SMS, por lo que le hemos enviado un código por correo electrónico.",
    checkFormAndTryAgain: "Compruebe el formulario y vuelva a intentarlo.",
    somethingWentWrong: "Se ha producido un error. Le rogamos que vuelva a intentarlo.",
    newUser: "Nuevo usuario",
    invitationFound: "Invitación encontrada",
    accountFound: "Cuenta encontrada",
    accountFoundUseEmailSmsNotReady:
        "Cuenta encontrada. Inicie sesión con su correo electrónico. El acceso por SMS aún no está configurado para este número en su cuenta.",
    smsLoginContactCareTeam:
        "El acceso por SMS no está disponible para este número. Diríjase al equipo que le invitó para obtener ayuda.",
    authMethodError: "Error del método de autenticación",
    smsLoginUnavailable:
        "El acceso por SMS aún no está disponible para este número. Inicie sesión con el correo electrónico de su cuenta.",
    email: "E-mail",
    emailTab: "E-mail",
    phoneTab: "Teléfono",
    emailPlaceholder: "p. ej. nombre@empresa.com",
    password: "Contraseña",
    phone: "Número de teléfono",
    enterEmailAddress: "Introduzca su dirección de correo electrónico",
    enterPhoneNumber: "Introduzca su número de teléfono",
    enterPhoneWithCountryCode: "Introduzca un número de teléfono con el prefijo internacional.",
    forgotPasswordEmailHint:
        "Introduzca la dirección de correo electrónico de su cuenta. Le enviaremos un código de verificación para restablecer la contraseña.",
    forgotPasswordPhoneHint:
        "Introduzca el número de teléfono de su cuenta. Le enviaremos un código de verificación por SMS.",
    sending: "Enviando...",
    backToSignIn: "Volver al inicio de sesión",
    backToForgotPassword: "Volver a « Contraseña olvidada »",
    backToConfirmAccount: "Volver a la confirmación de la cuenta",
    backToSignup: "Volver al registro",
    verifyYourAccount: "Verifique su cuenta",
    verifyEmailCodeHint: "Introduzca el código de verificación enviado a su dirección de correo electrónico.",
    verifySmsCodeHint: "Introduzca el código enviado a su número de teléfono.",
    verifying: "Verificando…",
    resendCode: "Volver a enviar el código",
    didNotReceiveCode: "¿No ha recibido un código?",
    resendConfirmationCode: "Volver a enviar el código de confirmación",
    needHelpContact: "¿Necesita ayuda? Contacte con",
    consentTermsPrefix: "Acepto las",
    termsOfUse: "Condiciones de uso",
    consentAnd: "y la",
    privacyPolicy: "Política de privacidad",
    selectHospitalLabel: "¿En qué hospital recibe seguimiento para estos cuidados?",
    selectHospitalPlaceholder: "Seleccione su hospital",
    selectHospitalToContinue: "Seleccione su hospital para continuar.",
    studyClinicianSignupHint: "Cree su cuenta clínica. Podrá añadir su organización más adelante.",
    studyClinicianSignupHintWithOrganisation:
        "Cree su cuenta clínica. Su organización ya está definida a partir de la invitación al estudio.",
    ownOrganisationNameLabel: "Nombre de la organización",
    ownOrganisationNamePlaceholder: "p. ej. Clínica ortopédica de la ciudad",
    ownOrganisationNameHint: "Así crea su organización en Patient Watch. Podrá invitar a sus compañeros más adelante.",
    organisationNameTooShort: "Introduzca un nombre de organización de al menos 3 caracteres.",
    signupSessionExpired: "Su sesión de registro ha caducado. Vuelva atrás y solicite un nuevo código.",
    loadingSignup: "Cargando el registro…",
    welcomeToPatientWatch: "Le damos la bienvenida a Patient Watch",
    invitedByLine: (name) => `${name} le ha invitado a unirse a Patient Watch.`,
    welcomeFirstTime: "Le damos la bienvenida - parece que es su primera visita.",
    choosePasswordDescription: "Elija una contraseña para completar la configuración de su cuenta.",
    alreadyHavePasswordSkip: "Omitir - ya tengo una contraseña",
    finishProfileSetup: "Completemos la configuración de su perfil.",
    continueToProfileSetup: "Continuar a la configuración del perfil",
    alreadySignedIn: "Ya ha iniciado sesión",
    alreadySignedInDescription:
        "Continúe hacia la aplicación, o cierre la sesión si necesita otra cuenta (por ejemplo, para abrir una invitación o un enlace de registro mientras ya ha iniciado sesión).",
    continueToProfile: "Continuar",
    continueToApp: "Continuar",
    notLoggedInResetPassword: "No ha iniciado sesión. Para restablecer su contraseña, vaya a:",
    authenticationComplete: "Autenticación correcta",
    authenticationCompleteDescription: "Ya ha iniciado sesión. Pulse Siguiente para continuar.",
    authenticationFailed: "Autenticación fallida",
    authenticationFailedDescription: "Enlace no válido. Le rogamos que vuelva a intentarlo.",
    noAccountFound: "Ninguna cuenta encontrada",
    noAccountForContact: (contact) => `Ninguna cuenta para ${contact}`,
    noAccountForDetails: "No hemos encontrado ninguna cuenta que corresponda a estos datos.",
    inviteOnlyPlatform: "Patient Watch es una plataforma solo por invitación. Seleccione su rol para continuar:",
    iAmPatient: "Soy paciente",
    iAmClinician: "Soy clínico",
    wrongEmailGoBack: "¿Ha indicado una dirección de correo electrónico incorrecta?",
    goBackAndTryAgain: "Vuelva atrás y vuelva a intentarlo.",
    noAccountChoosePath: "Si es clínico, puede empezar gratis de inmediato. Si es paciente, necesita una invitación.",
    noAccountPatientTitle: "Pacientes",
    noAccountPatientDescription:
        "Patient Watch está reservado a los pacientes invitados. Pida a su clínica que le invite, o solicite ayuda si cree que ya ha recibido una invitación.",
    noAccountPatientCta: "Necesito ayuda (paciente)",
    noAccountClinicianTitle: "Clínicos",
    noAccountClinicianDescription:
        "Invite a pacientes, recoja puntuaciones de resultados y siga su evolución - gratis para empezar, sin tarjeta de crédito. Pase a un plan superior solo cuando aumente su casuística.",
    noAccountClinicianCta: "Crear una cuenta gratuita",
    confirmAccountInviteTitle: "Se le invita a unirse a Patient Watch",
    couldNotVerifyContact: "No ha sido posible verificar sus datos de contacto",
    invitedToJoin: "Se le invita a unirse a Patient Watch",
    inviterInvitedYou: (name) => `${name} le ha invitado.`,
    confirmPhoneInviteBody:
        "Confirme su número de teléfono a continuación. Le enviaremos un código de verificación por SMS para que pueda completar la configuración de su cuenta.",
    confirmEmailInviteBody:
        "Confirme su dirección de correo electrónico a continuación. Le enviaremos un código de verificación para que pueda completar la configuración de su cuenta.",
    useInvitationContactDetails: "Usar los datos de contacto de su invitación",
    enterInvitationContactHint:
        "Introduzca la dirección de correo electrónico o el número de teléfono al que se envió su invitación de Patient Watch.",
    enterConfirmationCode: "Introduzca el código de confirmación",
    processing: "Procesamiento en curso",
    verifyYourEmailTitle: "Verifique su dirección de correo electrónico",
    verifyEmailIcon: "Verifique su dirección de correo electrónico",
    emailConfirmed: "Dirección de correo electrónico confirmada",
    emailConfirmedDescription: "Ya puede iniciar sesión.",
    verifyEmailWelcome: (firstName) =>
        `¡Le damos la bienvenida${firstName ? `, ${firstName}` : ""}! Debemos verificar su dirección de correo electrónico.`,
    verifyEmailSendHint: "Enviaremos un código de verificación de 6 dígitos a esta dirección de correo electrónico.",
    sendingCodeButton: "Enviando el código...",
    sendVerificationCodeButton: "Enviar el código de verificación",
    enterVerificationCode: "Introduzca el código de verificación",
    enterCodeSentTo: (email) => `Introduzca el código enviado a ${email}`,
    checkJunkFolder: "No olvide comprobar la carpeta de correo no deseado.",
    deleteAccount: "Eliminar la cuenta",
    deleteAccountReason: "Motivo de la eliminación de la cuenta",
    troubleAccessingTitle: "¿Dificultades para acceder a Patient Watch?",
    patientInviteMismatch: (email) =>
        `Si ha recibido una invitación, compruebe que la dirección de correo electrónico invitada sea exactamente ${email}.`,
    patientContactProvider:
        "Si cree que debería haber recibido una invitación, contacte con su proveedor de asistencia para confirmar sus datos de contacto.",
    contactSupportTeam: "Contactar con nuestro equipo de asistencia",
    interestedInPwTitle: "¿Le interesa Patient Watch?",
    interestedInPwBody1:
        "Patient Watch le ayuda a supervisar los resultados de sus pacientes y a mantener el contacto con su clínica. Empezar es rápido y sencillo - puede tenerlo en marcha en pocos minutos.",
    interestedInPwBody2:
        "Empiece con una cuenta gratuita - 5 diarios nuevos por periodo de facturación, sin tarjeta de crédito. Pase al plan Starter o Pro cuando necesite más capacidad. Los planes de pago incluyen una garantía de reembolso de 30 días si no le convienen.",
    signupStarterPlan: "Ver los planes de pago",
    carePlanInjection: "Su plan de cuidados incluye una inyección.",
    carePlanInjectionTo: (where, substance, amount) => {
        if (where && substance && amount) return `Inyección en ${where}: ${substance} (${amount}).`;
        if (where && substance) return `Inyección en ${where}: ${substance}.`;
        if (where && amount) return `Inyección en ${where} (${amount}).`;
        if (where) return `Seguimiento tras una inyección en ${where}.`;
        if (substance && amount) return `Inyección: ${substance} (${amount}).`;
        if (substance) return `Inyección: ${substance}.`;
        return "";
    },
    carePlanSurgery: "Su plan de cuidados incluye una cirugía.",
    carePlanSurgeryArea: (area) => `Su plan de cuidados incluye una cirugía (${area}).`,
    carePlanShockwave: "Su plan de cuidados incluye un tratamiento con ondas de choque.",
    authErrorTitle: "Error de autenticación",
    almostThere: "Casi terminado.",
    preparingAccount: "Un momento, estamos preparando su cuenta...",
    verifyEmailCallBody: (email) =>
        `Introduzca el código enviado a ${email}.\n\nNo olvide comprobar el correo no deseado.`,
    verifyingPhone: "Verificación del número de teléfono",
    verifyingEmail: "Verificación de la dirección de correo electrónico",
    phoneVerified: "Teléfono verificado",
    emailVerified: "Dirección de correo electrónico verificada",
    verifyingPhoneWait: "Un momento, estamos verificando su número de teléfono...",
    verifyingEmailWait: "Un momento, estamos verificando su dirección de correo electrónico...",
    phoneVerifiedSuccess: "Su número de teléfono se ha verificado. Configuremos ahora su cuenta.",
    emailVerifiedSuccess: "Su dirección de correo electrónico se ha verificado. Configuremos ahora su cuenta.",
    verifyPhoneError: "Vuelva a intentar verificar su número de teléfono o contacte con support@patient-watch.com",
    verifyEmailError:
        "Vuelva a intentar verificar su dirección de correo electrónico o contacte con support@patient-watch.com",
    verificationError: "Error de verificación",
    tryAgain: "Reintentar",
    freemiumSignupTitle: "Cree su cuenta gratuita",
    freemiumSignupDescription:
        "Invite a pacientes, recoja puntuaciones de resultados y siga su recuperación - listo en pocos minutos, sin tarjeta de crédito.",
    freemiumSignupBenefit1: "Invite a pacientes y recoja puntuaciones de resultados de inmediato",
    freemiumSignupBenefit2:
        "Los recordatorios automáticos mantienen a los pacientes implicados entre una consulta y otra",
    freemiumSignupBenefit3: "Siga la evolución a lo largo del tiempo con un panel clínico claro",
    freemiumSignupCta: "Crear una cuenta gratuita",
    freemiumSignupSubmitting: "Creando la cuenta…",
    freemiumSignupUpgradeHint: "¿Necesita un volumen mayor?",
    freemiumSignupSeePaidPlans: "Ver los demás planes",
    diaryInviteUnavailableTitle: "Esta invitación no está disponible",
    diaryInviteUnavailableCallout: "No se ha iniciado ningún diario",
    diaryInviteUnavailableBody: "No se puede añadir otro diario con el plan actual.",
    diaryInviteUnavailableNextStep: "Contacte con su clínica. Podrá invitarle de nuevo en cuanto tenga disponibilidad.",
    diaryInviteOwnerUnresolvedBody: "No ha sido posible iniciar este diario. Solicite un nuevo enlace de invitación.",
    mfaEnrollTitle: "Configurar la aplicación de autenticación",
    mfaEnrollDescription: "Escanee este código QR e introduzca el código de seis dígitos de su aplicación.",
    mfaManualSetup: "¿No puede escanear el código QR?",
    mfaQrCodeAlt: "Código QR de configuración de la aplicación de autenticación",
    mfaChallengeTitle: "Autenticación de dos factores",
    mfaChallengeDescription: "Introduzca el código de seis dígitos de su aplicación de autenticación.",
    mfaAuthenticatorCode: "Código de autenticación",
    mfaVerifyCode: "Verificar el código",
    mfaVerifying: "Verificando…",
    mfaLoading: "Cargando…",
    mfaSettingsTitle: "Seguridad de la aplicación de autenticación",
    mfaSettingsDescription: "Su aplicación de autenticación es necesaria para los accesos con privilegios.",
    mfaFactorActive: "Aplicación de autenticación activa",
    mfaReplaceFactor: "Sustituir la aplicación de autenticación",
    mfaReplaceConfirm: "¿Eliminar esta aplicación de autenticación y configurar una nueva ahora?",
};
